import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const TOOLBAR_OPTIONS = [
  [{ 'header': [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'indent': '-1' }, { 'indent': '+1' }],
  [{ 'align': [] }],
  ['blockquote'],
  ['clean'],
];

export function RichTextEditor({ value, onChange, placeholder = "Enter description..." }) {
  const modules = useMemo(() => ({
    toolbar: TOOLBAR_OPTIONS,
  }), []);

  const formats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'indent', 'align', 'blockquote',
  ];

  return (
    <div className="rich-text-editor" data-testid="rich-text-editor">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
      <style>{`
        .rich-text-editor .ql-container {
          font-size: 14px;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        /* Inner scroll area so the toolbar stays visible when content is long.
           Without this, the modal scrolls and the toolbar goes off-screen. */
        .rich-text-editor .ql-editor {
          min-height: 200px;
          max-height: 50vh;
          overflow-y: auto;
        }
        .rich-text-editor .ql-toolbar {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          background: #f8fafc;
          position: sticky;
          top: 0;
          z-index: 5;
        }
      `}</style>
    </div>
  );
}
